module.exports = __WEBPACK_EXTERNAL_MODULE_106__;


//////////////////
// WEBPACK FOOTER
// external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"}
// module id = 106
// module chunks = 0